import { render } from "./HistoryCardLog.vue?vue&type=template&id=54bb5ac5"
import script from "./HistoryCardLog.vue?vue&type=script&lang=js"
export * from "./HistoryCardLog.vue?vue&type=script&lang=js"

import "./HistoryCardLog.vue?vue&type=style&index=0&id=54bb5ac5&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__